export enum ACTIONS {
    CancelAllCancelableTasks,
    RetryFailedTasks
}
